import thingsThumbnailImage from '../../img/layer-thumbnails/thing-layer-image.png';
import trafficThumbnailImage from '../../img/layer-thumbnails/traffic-layer.png';
import incidentsThumbnailImage from '../../img/layer-thumbnails/incidents-layer.png';
import transportThumbnailImage from '../../img/layer-thumbnails/vehicle-restrictions-layer.png';

export const thingsThumbnail = thingsThumbnailImage;
export const trafficThumbnail = trafficThumbnailImage;
export const incidentsThumbnail = incidentsThumbnailImage;
export const transportThumbnail = transportThumbnailImage;
